import * as React from "react";
const SvgCheckmarkIconSmall = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path d="M13 4L6.125 12L3 8.36363" stroke="white" strokeWidth={1.5} strokeLinecap="square" /></svg>;
export default SvgCheckmarkIconSmall;